const ReviewTypes = {
    GET_ORDER_RATINGS: "GET_ORDER_RATINGS",
    GET_ORDER_RATINGS_SUCCESS: "GET_ORDER_RATINGS_SUCCESS"  
  };
  
  export { ReviewTypes };
  